import AccountIcon from "./components/ic_account_24px.svg.react";
import AddIcon from "./components/ic_add_24px.svg.react";
import ArrowBackIcon from "./components/ic_arrow_back_24px.svg.react";
import CancelIcon from "./components/ic_cancel_24px.svg.react.js";
import CheckIcon from "./components/ic_check_black_24px.svg.react.js";
import CheckCircleIcon from "./components/ic_check_circle_24px.svg.react.js";
import ChevronLeftIcon from "./components/ic_chevron_left_24px.svg.react";
import ChevronRightIcon from "./components/ic_chevron_right_24px.svg.react";
import CloseIcon from "./components/ic_close_24px.svg.react";
import EditIcon from "./components/ic_edit_24px.svg.react.js";
import FilterListIcon from "./components/ic_filter_list_24px.svg.react.js";
import FileDownloadIcon from "./components/ic_file_download_24px.svg.react";
import FileImageIcon from "./components/ic_file_image_24px.svg.react";
import FilePdfIcon from "./components/ic_file_pdf_24px.svg.react";
import FileUnknownIcon from "./components/ic_file_unknown_24px.svg.react";
import HelpIcon from "./components/ic_help_black_24px.svg.react";
import HelpOutlineIcon from "./components/ic_help_outline_24px.svg.react";
import InfoIcon from "./components/ic_info_black_24px.svg.react";
import InfoOutlineIcon from "./components/ic_info_outline_24px.svg.react";
import ArrowDownIcon from "./components/ic_keyboard_arrow_down_24px.svg.react";
import ArrowUpIcon from "./components/ic_keyboard_arrow_up_24px.svg.react";
import NotificationIcon from "./components/ic_notification_24px.svg.react";
import PrintIcon from "./components/ic_print_24px.svg.react";
import RemoveCircleIcon from "./components/ic_remove_circle_24px.svg.react";
import RemoveCircleOutlineIcon from "./components/ic_remove_circle_outline_24px.svg.react";
import RemoveIcon from "./components/ic_remove_24px.svg.react";
import SearchIcon from "./components/ic_search_24px.svg.react";
import ShoppingCartIcon from "./components/ic_shopping_cart_24px.svg.react";
import WarningIcon from "./components/ic_warning_24px.svg.react";

export { AccountIcon, AddIcon, ArrowBackIcon, CancelIcon, CheckIcon, CheckCircleIcon, ChevronLeftIcon, ChevronRightIcon, CloseIcon, EditIcon, FileDownloadIcon, FileImageIcon, FilePdfIcon, FileUnknownIcon, FilterListIcon, HelpIcon, HelpOutlineIcon, InfoIcon, InfoOutlineIcon, ArrowDownIcon, ArrowUpIcon, NotificationIcon, PrintIcon, RemoveCircleIcon, RemoveCircleOutlineIcon, RemoveIcon, SearchIcon, ShoppingCartIcon, WarningIcon };


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper-icons/es/index.js
// module id = null
// module chunks = 